import React, { Component } from 'react';
import { GlobalNetwork } from "../../Networks";
import Experiences from "../../Experiences"
import Alumni from "../../Experiences/Alumni";



export default class HomeContent extends Component {
  render() {
    return (
      <React.Fragment>
        <Experiences />
        <Alumni />
        <GlobalNetwork />
      </React.Fragment>
    );
  }
}





// WEBPACK FOOTER //
// ./src/Components/Layout/HomeDisplay/index.js